import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { TableNavContratados } from '../views/contratados'
import { TableNavContratos } from '../views/contratos'
import { TableNotasFiscaisNav } from '../views/baixas'

class ContratosCardNav extends Component {
  constructor() {
    super()
    this.state = {
      selectedIndex: 0,
    }
  }

  handleTabChange(index) {
    this.setState({ selectedIndex: index })
  }

  getComponent(index) {
    switch (index) {
      case 0:
        return <TableNavContratados rows={this.props.data[index]} />
      case 1:
        return <TableNotasFiscaisNav rows={this.props.data[index]} />
      case 4:
        return (
          <TableNavContratos
            tableClass="table-vencer"
            rows={this.props.data[index]}
          />
        )
      default:
        return null
    }
  }

  render() {
    const tabs = [
      { label: 'Maiores fornecedores', link: 'fornecedores', icon: 'gavel' },
      { label: 'Últimas baixas', link: 'baixas', icon: 'attach_money' },
      {
        label: 'Contratos sem fiscalização',
        link: 'semfiscalizacao',
        icon: 'priority_high',
      },
      { label: 'Contratos sem movimento', link: 'movimento', icon: 'warning' },
      { label: 'Contratos à vencer', link: 'vencendo', icon: 'access_alarm' },
    ]

    const headerColor = this.props.backgroundColor || '#9c27b0'

    return (
      <div className="card card-nav-tabs">
        <div
          className="card-header card-header-danger"
          style={{ backgroundColor: headerColor }}>
          <div className="nav-tabs-navigation">
            <div className="nav-tabs-wrapper">
              <ul className="nav nav-tabs" role="tablist">
                {tabs.map((tab, key) => {
                  const isActive = key === this.state.selectedIndex
                  return (
                    <li
                      className={`nav-item ${isActive ? 'active-tab-item' : ''}`}
                      key={`tab-item-${key}-${this.state.selectedIndex}`}>
                      <a
                        className={`nav-link ${isActive ? 'active' : ''} ${key === 0 ? 'first-tab' : ''}`}
                        onClick={() => this.handleTabChange(key)}
                        data-tab-index={key}>
                        <i className="material-icons">{tab.icon}</i> {tab.label}
                      </a>
                    </li>
                  )
                })}
              </ul>
            </div>
          </div>
        </div>
        <div className="card-content">
          <div className="tab-content">
            <div className="tab-pane active" style={{ padding: '15px 0' }}>
              {this.getComponent(this.state.selectedIndex)}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default withRouter(ContratosCardNav)



// WEBPACK FOOTER //
// ./src/components/ContratosCardNav.js